<ion-header>
  <ion-toolbar>
    <ion-title>global</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

</ion-content>
